import { Component } from '@angular/core';

@Component({
    templateUrl: './bi-queriesPage.component.html',
})
export class BiQueriesPageComponent {
}
